import { FormHandles } from "models/propTypes/genericFormProps";
import { useLocation, useNavigate } from "react-router-dom";
import { TodoConstants } from "utils/constants";
import { UrlHelper } from "utils/helpers";
import { getCostForwardingValuesToCarry } from "components/costForwardingMarking";

function useReceiptViewInfo(id: number | string, formRef: React.RefObject<FormHandles>) {
  const location = useLocation();
  const navigate = useNavigate();

  // The marking goes along whole: a field left at its default would otherwise be missing, and the
  // details page would approve the document without the marking the user chose in the to-do.
  const getUpdatedValues = () => {
    const updatedValues =
      (formRef.current && formRef.current.getUpdatedValues && formRef.current.getUpdatedValues()) || {};
    return { ...updatedValues, ...getCostForwardingValuesToCarry(formRef.current?.getValues?.() ?? {}) };
  };

  const onViewButtonClick = () => {
    navigate(UrlHelper.formatPath(`/Receipt/${id}`), {
      state: {
        background: location,
        [TodoConstants.RouteTodoSelectionKey]: getUpdatedValues && getUpdatedValues(),
      },
    });
  };

  return onViewButtonClick;
}

export default useReceiptViewInfo;
